__webpack_require__.p = "https://assets2.varsitytutors.com/vt-self-service-ui/";